import { useCallback } from "react";

interface ResizerProps {
  side: "left" | "right";
  width: number;
  min: number;
  max: number;
  onResize: (width: number) => void;
}

/** A thin draggable divider for resizing a side panel. */
export function Resizer({ side, width, min, max, onResize }: ResizerProps) {
  const onPointerDown = useCallback(
    (e: React.PointerEvent) => {
      e.preventDefault();
      const startX = e.clientX;
      const startWidth = width;
      const move = (ev: PointerEvent) => {
        const delta = side === "left" ? ev.clientX - startX : startX - ev.clientX;
        onResize(Math.min(max, Math.max(min, startWidth + delta)));
      };
      const up = () => {
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", up);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      };
      window.addEventListener("pointermove", move);
      window.addEventListener("pointerup", up);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    },
    [side, width, min, max, onResize]
  );

  return <div className="resizer" onPointerDown={onPointerDown} role="separator" aria-orientation="vertical" />;
}
